module.exports = __webpack_public_path__ + "img/dablogo.1b209879.png";